import { create } from 'zustand';
import { persist } from 'zustand/middleware';
let notifCounter = 0;
export const useNotificationStore = create()(persist((set, get) => ({
    notifications: [],
    unreadCount: 0,
    addNotification: (n) => {
        const notification = {
            ...n,
            id: `notif-${Date.now()}-${++notifCounter}`,
            read: false,
            timestamp: new Date().toISOString(),
        };
        set((state) => ({
            notifications: [notification, ...state.notifications].slice(0, 50),
            unreadCount: state.unreadCount + 1,
        }));
    },
    markAsRead: (id) => set((state) => {
        const notifications = state.notifications.map((n) => n.id === id ? { ...n, read: true } : n);
        return {
            notifications,
            unreadCount: notifications.filter((n) => !n.read).length,
        };
    }),
    markAllAsRead: () => set((state) => ({
        notifications: state.notifications.map((n) => ({ ...n, read: true })),
        unreadCount: 0,
    })),
    clearAll: () => set({ notifications: [], unreadCount: 0 }),
    removeNotification: (id) => set((state) => {
        const notifications = state.notifications.filter((n) => n.id !== id);
        return {
            notifications,
            unreadCount: notifications.filter((n) => !n.read).length,
        };
    }),
}), { name: 'projectmanmd-notifications' }));
//# sourceMappingURL=notification-store.js.map